const params = {
    "DO_HOME_URL": "https://do.adventurees.net",
    "DO_CREATE_URL": "https://do.adventurees.net/user/create.html",
    "DEV_DO_HOME_URL": "https://do.dev.adventurees.net",
    "DEV_DO_CREATE_URL": "https://do.dev.adventurees.net/user/create.html",
    "CONTACT_EMAIL": "contact@adventurees-alliance.com",
    "BASE_URL": "https://www.adventurees-alliance.com"
}

export default params;